<template>
  <div class="app-main-inner app-main-page-tab">
    <div class="app-main-inner-row" style="justify-content: left;">
      <span>{{ $t('SystemMaintenance.QueryFileType') }}</span>
      <el-input v-model="keyword" no="keyword" :disabled="treeMask" :placeholder="$t('Message.EnterKeyword')" style="width: 190px" />
      <el-button no="query" :disabled="treeMask" type="primary" style="margin-left: 17px;" @click="queryByKeyword">{{ $t('common.btn.query') }}</el-button>
    </div>
    <div class="app-main-inner-row row-grid">
      <div style="position:relative;width:15%;min-width:190px;border:1px solid #ccc;display: flex;cursor: pointer;">
        <div v-show="treeMask" style="position:absolute;z-index:99999;height:100%;width:100%;background-color:rgba(0,0,0,.6);" />

        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docCategoryTree.gridOptions"
          :column-defs="docCategoryTree.columnDefs"
          :row-data="filterRowData"
          style="width:100%;"
        />
      </div>
      <div style="min-width:85%;border:1px solid #ccc;display: flex;">
        <doc-category ref="doc" :current-data="currentData" @flush="flush" @maskTree="maskTree" />
      </div>
    </div>
  </div>
</template>

<script>

import docCategory from './docCategory'
import {
  getDocCategoryTypeTree
} from '@/api/sysManage/baseConfig/docCategory'
import { getLoading } from '@/utils/utilBaseElement'
import { sortByMultiField } from '@/utils'

export default {
  name: 'DocumentTypeManagement',
  components: {
    docCategory
  },
  filters: {},
  data() {
    return {
      currentData: {},
      loading: null,
      treeMask: false,
      keyword: '',
      docCategoryTree: {
        columnDefs: [
          {
            headerName: 'Path',
            field: 'path',
            width: 80,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: false,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SystemMaintenance.Name'),
            width: 280,
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (params.data.type === 0) {
                  return params.data.chineseName
                }
                return params.data.level + '. ' + params.data.chineseName
              }
            }
          },
          onRowClicked: this.onRowClick
        },
        rowData: []
      },
      filterRowData: []
    }
  },
  mounted() {
    this.fetchDocCategoryTypeTree()
  },
  methods: {
    onRowClick(event) {
      this.currentData = event.data
    },
    async fetchDocCategoryTypeTree() {
      this.loading = getLoading()
      await getDocCategoryTypeTree().then(res => {
        const sortedDetails = sortByMultiField(res.data, ['level', 'type', 'code', 'chineseName'], false)
        this.docCategoryTree.rowData = sortedDetails
      }).finally(() => {
        this.loading.close()
      })
      this.queryByKeyword()
    },
    async flush(optData) {
      const self = this
      // const originScrollTop = this.docCategoryTree.gridOptions.api.gridPanel.eBodyViewport.scrollTop
      const expandNodes = []
      let selectedNode
      const expandNodeIds = []
      this.docCategoryTree.gridOptions.api.forEachNode((node, index) => {
        if (node.expanded) {
          expandNodeIds.push(node.data.uuid)
        }
      })
      const rootPath = this.currentData.path.split(',')[0]
      await this.fetchDocCategoryTypeTree()
      const readySelectUuid = optData.uuid || optData.parentUuid
      this.docCategoryTree.gridOptions.api.forEachNode((node, index) => {
        if (expandNodeIds.includes(node.data.uuid)) {
          expandNodes.push(node)
        }
        if (readySelectUuid === node.data.uuid && node.data.path.startsWith(rootPath)) {
          selectedNode = node
          self.currentData = node.data
        }
      })
      this.resetNodeShowStatus(expandNodes, selectedNode)
    },
    resetNodeShowStatus(expandNodes, selectedNode) {
      const self = this
      expandNodes.forEach(node => {
        node.setExpanded(true)
      })
      // selectedNode.setSelected(true)
      if (selectedNode) {
        const gridApi = this.docCategoryTree.gridOptions.api
        gridApi.setFocusedCell(selectedNode.rowIndex, gridApi.columnController.getAllDisplayedColumns()[0])
      }
      // setTimeout(() => {
      //   self.docCategoryTree.gridOptions.api.gridPanel.eBodyViewport.scrollTop = originScrollTop
      // }, 100)
    },
    maskTree(mask) {
      this.treeMask = mask
    },
    queryByKeyword() {
      this.currentData = {}
      if (this.docCategoryTree.gridOptions.api) {
        this.docCategoryTree.gridOptions.api.clearFocusedCell()
      }
      if (this.keyword) {
        const matchPathes = []
        for (const row of this.docCategoryTree.rowData) {
          if (row.chineseName.indexOf(this.keyword) > -1) {
            matchPathes.push(row.path)
          }
        }
        this.filterRowData = []
        for (const row of this.docCategoryTree.rowData) {
          for (const matchPath of matchPathes) {
            if (matchPath.startsWith(row.path) || row.path.startsWith(matchPath)) {
              this.filterRowData.push(row)
              break
            }
          }
        }
        this.$nextTick(() => {
          this.docCategoryTree.gridOptions.api.expandAll()
        })
      } else {
        this.filterRowData = this.docCategoryTree.rowData
      }
    }
  }
}
</script>

<style scoped>

</style>
